import Button from '@mui/material/Button';
import { useFormContext } from 'react-hook-form';

import { useCloverPaymentForm } from 'payments/providers/CloverPaymentFormProvider';
import { useErrorSnackbar } from 'reservations/base/hooks/useSnackbar';
import { useLoadingSpinner } from 'reservations/base/providers/LoadingSpinnerProvider';
import { useIsSubjectToCancellationFee } from 'reservations/feePolicy/hooks';
import { useCreateBookingMutation } from 'reservations/form/queries/useCreateBookingMutation';
import { usePreviewModeContext } from 'reservations/preview/providers/PreviewModeProvider';

export const CreateReservationButton = () => {
  const isSubjectToCancellationFee = useIsSubjectToCancellationFee();
  const { isPreview } = usePreviewModeContext();
  const { handleIsLoading, handleHasLoaded } = useLoadingSpinner();
  const { handleSubmit: handleSubmitBookingForm } = useFormContext();
  const mutation = useCreateBookingMutation();
  const handlePaymentForm = useCloverPaymentForm()?.handlePaymentForm;
  const enqueueErrorSnackbar = useErrorSnackbar();

  const handleSubmit = async () => {
    if (isSubjectToCancellationFee && handlePaymentForm) {
      const paymentSuccess = await handlePaymentForm();
      if (!paymentSuccess) {
        enqueueErrorSnackbar(
          'PAYMENT_FAILED',
          'Unable to process your payment. Please try again.'
        );
        return;
      }
    }

    handleIsLoading('Booking your reservation...');

    const onValidation = (errors: any) => {
      if (errors?.token) {
        enqueueErrorSnackbar(
          'TOKEN_REQUIRED',
          'Credit card required. Please add your payment information to complete this reservation.'
        );
      }
      handleHasLoaded();
    };

    return handleSubmitBookingForm(
      (data: Record<string, any>) => mutation.mutate(data),
      onValidation
    )();
  };

  return (
    <Button
      data-testid="create-reservation-button-v2"
      onClick={handleSubmit}
      disabled={isPreview}
      size="fullWidth"
    >
      Reserve
    </Button>
  );
};
